// ✅ Importaciones principales
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';  // Hook para redirecciones
import { ButtonSecundario } from '../../ui';     // Botón reutilizable del diseño UI

// 🔹 Componente funcional para mostrar el mensaje de verificación
const VerificacionEnviada: React.FC = () => {
  const navigate = useNavigate();               // Hook que permite navegar entre rutas
  const email = localStorage.getItem('registroEmail'); // Recupera el email guardado en el registro

  // 🧭 useEffect: se ejecuta al montar el componente
  // Si el usuario accede a esta página directamente sin haberse registrado (sin email en localStorage),
  // se le redirige automáticamente al formulario de registro.
  useEffect(() => {
    if (!email) {
      navigate('/registrar'); // Redirige si no hay email almacenado
    }
  }, [email, navigate]);

  // 🔹 Función para volver a la página de inicio de sesión
  const handleVolver = () => {
    navigate('/sign');
  };

  // 🎨 Renderizado del mensaje de verificación
  return (
    <div className="min-h-screen text-white flex flex-col items-center justify-center px-4">
      {/* Contenedor con fondo oscuro, bordes redondeados y sombra */}
      <div className="bg-zinc-800 p-8 rounded-2xl shadow-lg text-center max-w-md w-full">
        {/* Título principal */}
        <h1 className="text-2xl font-bold mb-4">📧 Verifica tu correo</h1>

        {/* Mensaje principal con el email al que se envió el enlace */}
        <p className="mb-6">
          Hemos enviado un enlace de verificación a{' '}
          <span className="font-semibold text-blue-400">{email}</span>.
        </p>

        {/* Instrucciones adicionales */}
        <p className="mb-6">
          Por favor revisa tu bandeja de entrada (y también la carpeta de spam) para completar tu registro.
        </p>

        {/* Botón para volver al inicio de sesión */}
        <ButtonSecundario onClick={handleVolver} className="w-full">
          Ir a Iniciar Sesión
        </ButtonSecundario>
      </div>
    </div>
  );
};

// Exportamos el componente para su uso en las rutas
export default VerificacionEnviada;
